import { css } from '@compiled/react';

import { Image } from '@/libraries/design/components/image/src/image';

const cornerLogoCss = css({
	position: 'absolute',
	insetBlockStart: '30px',
	insetInlineStart: '40px',
	// Keep the logo above sibling content but non-interactive so it never
	// blocks clicks on the onboarding view underneath.
	pointerEvents: 'none',
	zIndex: 1,
});

const logoImgCss = css({
	width: '96px',
	height: 'auto',
	display: 'block',
});

/**
 * Fixed Loom wordmark logo pinned to the top-left corner of the Loom
 * onboarding screen. Rendered absolutely so it sits independently of the
 * centered step content: 40px from the left and 30px from the top.
 *
 * Assumes the nearest positioned ancestor is the onboarding page layout
 * (the corner is expected to be empty).
 */
export const CornerLoomLogo = () => (
	<div css={cornerLogoCss} data-testid="loom-corner-logo">
		<Image
			css={logoImgCss}
			src="https://dam-cdn.atl.orangelogic.com/AssetLink/k3fiwrhg75onexw4rg02bs3a6iov3l4g.svg"
			alt="Loom"
		/>
	</div>
);
